import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'

import { AlertDialog } from '@/shared/ui'

type Props = Omit<ComponentProps<typeof AlertDialog>, 'title' | 'content'>

export const InProgressContractDialog = (props: Props) => {
  const t = useTranslations('room_detail.dialog.already_lease')

  return (
    <AlertDialog
      {...props}
      title={t('title')}
      content={t('description')}
      confirmText={t('button')}
    />
  )
}
